import { useEffect, useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { Company } from "@/types/company";

interface UseCompanyDetailsOptions {
  companyId: Company["id"] | undefined;
}

export const useCompanyDetails = ({ companyId }: UseCompanyDetailsOptions) => {
  const [company, setCompany] = useState<Company | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (companyId === undefined) return;

    const fetchCompanyDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axiosInstance.get<Company>(
          `companies/companies/${companyId}/`,
        );
        setCompany(response.data);
      } catch (err: unknown) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, [companyId]);

  return {
    company,
    loading,
    error,
  };
};
